<div id="money-movement-acknowledgement">
    <span id="subtitle" class="section-title">Money movement acknowledgement</span>
    <div [ngClass]="[isChecked ? 'acknowledge-box-valid' : 'acknowledge-box-default', ((submitClicked$ | async) && hasError) ? 'acknowledge-box-invalid' : '']">
        <div class="row">
            <div class="col-1">
                <input id="acknowledgeCheckbox" type="checkbox" value="isChecked"
                    (change)="checkboxValueChanged()" name="account-transfer-checkbox">
            </div>
            <div class="col-2">
                <label for="acknowledgeCheckbox">
                    {{moneyMovementAcknowledgeText}}
                    <span *ngIf='moneyMovementAcknowledgeNote'>
                      <br><br>
                      {{moneyMovementAcknowledgeNote}}
                    </span>
                </label>
            </div>
        </div>
    </div>
</div>
<div class="row" *ngIf="(submitClicked$ | async) && hasError">
    <label class="error-text">{{moneyMovementAcknowledgeError}}</label>
</div>
<sdps-divider variation="secondary"></sdps-divider>
